/**
 * Module for sProgress bar
 * @module services/sProgress
 * @preferred
 */

import singletons from "@/services/singletons";

let sProgress = {
  get startAuto() {
    return singletons.progressBar.startAuto;
  },
  get start() {
    return singletons.progressBar.start;
  },
  get pause() {
    return singletons.progressBar.pause;
  }
};

export default sProgress;
